import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';
import { session } from '@/shared/utils/storage';
import { SessionEnum } from '@/enums/session';

import FinanceBusiness from '@/mixins/finance-business';
import { ubtSendError } from '@/shared/utils/ubt';
import { checkBindCardNeedVerify } from '@/shared/verify-credit-controller';
import CardBankList from './card-bank-list';
import MyCardList from './my-card-list';
import type { SessionFrom } from './types';
import { FormInfomation } from './types';

@Component
export default class CardList extends Mixins(
  FinanceBusiness,
) {
  @Prop(String) readonly commodityId!: string;

  @Prop(String) readonly capitalCode!: string;

  @Prop(String) readonly loanOrderId!: string;

  @Prop(String) readonly entryFrom!: FormInfomation;

  // 用户选择银行卡前的来源页面，目前只适配于还款流程
  @Prop(String) readonly fromPath!: string;

  // 用户选择银行后的返回页面，目前只适配于还款流程
  @Prop(String) readonly backPath!: string;

  // 用于选择银行卡后继续前进的页面，目前只适配于还款流程
  @Prop(String) readonly forwardUrl!: string;

  /** 回退时的history序列 */
  @Prop(String) readonly fromHistoryLength!: string;

  /** 是否-预授信流程 */
  @Prop(Boolean) readonly isPreCredit!: boolean;

  @Prop(Boolean) readonly ocrAfterLoan!: boolean;

  private get sessionFrom() {
    return session.get(SessionEnum.toBindCard) as SessionFrom;
  }

  private async created() {
    try {
      if (this.ocrAfterLoan) {
        await checkBindCardNeedVerify([this.commodityId]);
      } else if (this.isPreCredit) {
        /** 预授信流程-只检验前置OCR流程 */
        await this.preCreditBeforeEnterApplyCheck();
      } else {
        /** 全量检验用户资料是否完整，不完整就跳资料页补充(不区分是否h5环境) */
        await this.checkOuterChannel({ commodityIds: [this.commodityId] });
      }
    } catch (err) {
      ubtSendError(err as Error);
    }
  }

  private render() {
    if (
      [
        FormInfomation.Product, FormInfomation.Repay, FormInfomation.Credit,
        FormInfomation.QuickWithdraw,
      ].indexOf(this.entryFrom) >= 0
    ) {
      return (
        <div>
          <CardBankList
            entryFrom={this.entryFrom}
            commodityId={this.commodityId}
            sessionFrom={this.sessionFrom}
            backPath={this.backPath}
            fromPath={this.fromPath}
            forwardUrl={this.forwardUrl}
            capitalCode={this.capitalCode}
            loanOrderId={this.loanOrderId}
            fromHistoryLength={this.fromHistoryLength}
            isPreCredit={this.isPreCredit}
            ocrAfterLoan={this.ocrAfterLoan}
            cardListTitle='我的银行卡'
            cardAddTitle='新增银行卡'
          />
        </div>
      );
    }
    return <MyCardList />;
  }
}
